import guard from "@/guard";
import { alert } from "@cems-eco/core/src/utils/widget";

export const permissionDirective = {
  mounted(el, binding) {
    console.log(binding.value);
    if (!Array.isArray(binding.value)) {
      alert("Error", "Permission value must be array", "error");
      return;
    }

    if (!guard.hasPermission(binding.value)) {
      el.style.display = "none";
      el.setAttribute(
        "style",
        (el.getAttribute("style") || "") + ";display: none !important"
      ); 
    }
  },
};

export function HasPermission(permissions: string[]) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      if (guard.hasPermission(permissions, true)) {
        return originalMethod.apply(this, args);
      } 
    };
  };
}

export function MustHasPermission(permissions: string[]) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      if (guard.mustHasPermission(permissions, true)) {
        return originalMethod.apply(this, args);
      } 
    };
  };
}